import React from "react";
import { Link } from "react-router-dom";
import ADNavbar from "../components/ADNavbar";
import SiteFooter from "../components/SiteFooter";
import { ArrowLeft, ExternalLink } from "lucide-react";

const ARTICLE_URL = "https://orlandovoyager.com/interview/hidden-gems-meet-adris-davis-of-prestigious-travel-club-foundation/";
const ARTICLE_IMG = "https://orlandovoyager.com/wp-content/uploads/sites/13/2026/08/c-1785703739253-personal_1785703701238_1785703701238_adris_davis_adrisorlandovoyager.jpg";

const PressPage = () => (
  <>
    <ADNavbar />

    <section className="pt-28 pb-20 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
          <ArrowLeft size={12} /> Back
        </Link>

        <p className="text-[10px] tracking-[0.3em] uppercase text-gray-400 mb-2">Press & Features</p>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          In the Press
        </h1>

        {/* Article Card */}
        <a
          href={ARTICLE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all duration-300 group"
        >
          <div className="flex flex-col md:flex-row">
            <div className="md:w-5/12 overflow-hidden">
              <img
                src={ARTICLE_IMG}
                alt="Adris Davis - OrlandoVoyager"
                className="w-full h-64 md:h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
              />
            </div>
            <div className="md:w-7/12 p-6 md:p-8 flex flex-col justify-center">
              <p className="text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-3">OrlandoVoyager &middot; August 2026</p>
              <h2
                className="text-lg md:text-xl font-bold text-gray-900 mb-3 group-hover:text-gray-700 transition-colors leading-snug"
                style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
              >
                Hidden Gems: Meet Adris Davis of Prestigious Travel Club Foundation
              </h2>
              <p className="text-sm text-gray-400 leading-relaxed mb-4">
                "My story began with a simple belief that success should be used to create opportunities for other people."
              </p>
              <span className="inline-flex items-center gap-1 text-xs text-gray-500 group-hover:text-gray-700 transition-colors">
                Read Full Article <ExternalLink size={10} />
              </span>
            </div>
          </div>
        </a>

        {/* Article Excerpt */}
        <div className="mt-16 pt-12 border-t border-gray-100">
          <p className="text-[10px] tracking-[0.3em] uppercase text-gray-400 mb-6">Excerpt</p>

          <div className="text-gray-500 text-sm leading-[1.9] space-y-6">
            <div>
              <p className="text-xs font-medium text-gray-700 uppercase tracking-wider mb-2">On where it all began:</p>
              <p>"As I built my businesses, I became increasingly aware of how many individuals and families were facing difficult circumstances without the resources, guidance, or support they needed. I knew I wanted my work to be about more than generating revenue. I wanted it to have a purpose."</p>
            </div>

            <div>
              <p className="text-xs font-medium text-gray-700 uppercase tracking-wider mb-2">On challenges:</p>
              <p>"One of the greatest challenges has been trying to meet real needs in the community while working with limited resources. The need is often greater than the funding available, so I have had to learn how to prioritize, build strong relationships, and make every contribution create the greatest possible impact."</p>
            </div>

            <div>
              <p className="text-xs font-medium text-gray-700 uppercase tracking-wider mb-2">On living with purpose:</p>
              <p>"Living with congestive heart failure has taught me that time, energy, and health should never be taken for granted. I have had to learn that strength does not always mean pushing through everything alone. Sometimes strength means slowing down, asking for support, trusting your team, and focusing your energy on what matters most."</p>
            </div>

            <div>
              <p className="text-xs font-medium text-gray-700 uppercase tracking-wider mb-2">On what sets them apart:</p>
              <p>"What sets us apart is that our charitable mission is directly connected to the businesses we operate. A portion of the proceeds from our business activities helps support our nonprofit initiatives, allowing our clients to know that their purchase is also contributing to something larger than themselves."</p>
            </div>

            <div>
              <p className="text-xs font-medium text-gray-700 uppercase tracking-wider mb-2">On the most important lesson:</p>
              <p className="italic" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>"Impact is not measured only by how much you accomplish, but by how many people are better because you chose to act."</p>
            </div>
          </div>

          <a
            href={ARTICLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 mt-10 text-sm text-gray-900 border border-gray-900 px-8 py-2.5 tracking-wider uppercase hover:bg-gray-900 hover:text-white transition-all duration-300"
          >
            Read Full Article <ExternalLink size={12} />
          </a>
        </div>
      </div>
    </section>

    <SiteFooter />
  </>
);

export default PressPage;
